// Sitemap.js
import React from "react";

const Sitemap = () => {
  return (
    <div style={{ display: "none" }}>
      <a href="/?cardId=1#news-and-events">News 1</a>
      <a href="/?cardId=2#news-and-events">News 2</a>
      <a href="/?cardId=4#news-and-events">News 4</a>
    </div>
  );
};

export default Sitemap;
